"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useState } from "react";
import Image from "next/image";
export const LiveTag = t0 => {
  const $ = _c(1);
  const {
    id
  } = t0;
  useState(id);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="bg-EB5757 w-[75px] h-[30px] flex items-center justify-center gap-2"><div className="relative flex items-center justify-center"><div className="w-2 h-2 bg-FFFFFF rounded-full" /><div className="absolute w-3 h-3 border-2 border-FFFFFF/40 rounded-full animate-ping" /></div><span className="text-FFFFFF text-16-tamil-600 uppercase tracking-wide">Live</span></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  return t1;
};